import {Storage} from '../configs'

export function authHeader() {
    let user=Storage.getUser()
 
    if (user && user.token) {
        return { 'Authorization': 'Bearer ' + user.token };
    } else {
        return {};
    }
}